import { isDev } from "@workwave-tidal/core/base";
import { useEffect, useRef } from "react";
const emptyObject = {};
const __DEV__ = isDev();
function useFormInitialFields(formApi, updateMode, _name, fields, config = emptyObject, verbose) {
  const prevSource = useRef({ fields, config, verbose });
  useEffect(() => {
    if (__DEV__) {
      if (prevSource.current.config.mode === "strict") {
        const prevFields = Object.keys(prevSource.current.fields);
        const nextFields = Object.keys(fields);
        if (prevFields.length !== nextFields.length) {
          throw new Error(
            `[useCreateForm] -- Adding or removing Form Fields dynamically through the Form Fields configuration is a no-op.`
          );
        }
        if (prevFields.sort().join("") !== nextFields.sort().join("")) {
          throw new Error(
            `[useCreateForm] -- Changing Form Fields dynamically through the Form Fields configuration is a no-op.`
          );
        }
      }
    }
    const values = Object.entries(fields).reduce((acc, [fieldName, field]) => {
      acc[fieldName] = field.initialValue ?? field.value;
      return acc;
    }, {});
    formApi.reset(updateMode, values, false);
    const verbose2 = prevSource.current.verbose;
    if (verbose2) console.log(`[useCreateForm] -- Update Field Initial Values.`);
  }, [formApi, updateMode, fields]);
  useEffect(() => void (prevSource.current = { fields, config, verbose }), [fields, config, verbose]);
}
export {
  useFormInitialFields
};
//# sourceMappingURL=useFormInitialFields.js.map
